<template>
    <div class="company-information-loader">
        <div class="company-information-loader__labels">
            <CompassSkeleton size="x-large" />
            <CompassSkeleton size="x-large" />
            <CompassSkeleton size="x-large" />
            <CompassSkeleton size="x-large" />
        </div>
        <div class="company-information-loader__fields">
            <CompassSkeleton size="x-large" />
            <CompassSkeleton size="x-large" />
            <CompassSkeleton size="x-large" />
            <CompassSkeleton size="x-large" />
        </div>
    </div>
</template>
<style lang="scss" scoped>
.company-information-loader {
    align-items: flex-start;
    display: grid;
    gap: var(--spacing-4);
    grid-template-columns: repeat(12, minmax(0, 1fr));

    &__labels,
    &__fields {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
        grid-column: span 4;
    }

    &__fields {
        grid-column: span 8;
    }
}
</style>
